import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PhonePipe } from './phone/phone.pipe';
import { KeepHtmlPipe } from './keep-html/keep-html.pipe';
import { Char2brPipe } from './char2br/char2br.pipe';
import { Slash2brPipe } from './slash2br/slash2br.pipe';
import { Pipe2brPipe } from "./pipe2br/pipe2br.pipe";
import { ResizePipe } from './resize/resize.pipe';
import { CitySizePipe } from './city-size/city-size.pipe';
import { RmSlashPipe } from './rm-slash/rm-slash.pipe';
import { RmLongVowelPipe } from './rm-long-vowel/rm-long-vowel.pipe';

@NgModule({
  declarations: [
    PhonePipe,
    KeepHtmlPipe,
    Char2brPipe,
    Slash2brPipe,
    Pipe2brPipe,
    ResizePipe,
    CitySizePipe,
    RmSlashPipe,
    RmLongVowelPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    PhonePipe,
    KeepHtmlPipe,
    Char2brPipe,
    Slash2brPipe,
    Pipe2brPipe,
    ResizePipe,
    CitySizePipe,
    RmSlashPipe,
    RmLongVowelPipe,
  ],
})
export class PipesModule {}
